export default __webpack_public_path__ + "static/media/bosch_logo_01.06c6edd9.svg";